import React, { useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ContinueCancelButtons from "../../../shared/components/ContinueCancelButtons.jsx";
import BackAnchor from "../../../shared/components/BackAnchor.jsx";
import { setQuestionAnswer, setQuestionAnswerFrench } from "../../../redux/actions.js";
import { addToGoogleDataLayer } from "../../../shared/const/utls";

const StartHarpPageView = ({ t, i18n }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { search } = useLocation();
  const url = new URLSearchParams(search);
  const isSummary = url?.get("isSummary");
  const disableGApush = useMemo(() => {
    return JSON.parse(params.disableGA || false);
  }, [params]);
  const [selectOptionError, setSelectOptionError] = useState(false);

  useEffect(() => {
    if (i18n?.language === "en") {
      document.title =
        "Continuing without uploading - HARP - Government of Nova Scotia";
    } else {
      document.title =
        "Continuer sans télécharger – PAC – Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language]);

  useEffect(() => {
    if (!disableGApush) {
      try {
        addToGoogleDataLayer(
          "CONTINUE-WITHOUT-UPLOAD",
          "HARP Application",
          i18n.language
        );
        window.scrollTo(0, 0);
      } catch (e) {
        console.log(e);
      }
    }
  }, [i18n.language, disableGApush]);

  const questionDataList = useSelector((state) => state?.app?.questionDataList);

  const heatingProofUpload =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 14)
    ].flag;

  const onNext = () => {
    if (heatingProofUpload === undefined) {
      setSelectOptionError(true);
      return;
    }

    if (heatingProofUpload) {
      navigate(`/${i18n.language}${t("routes.upload_heating_bill")}${isSummary ? `?isSummary=true` : ''}`);
    } else {
      if (isSummary) {
        navigate(`/${i18n.language}${t("routes.review_summary")}`);
      } else {
        navigate(`/${i18n.language}${t("routes.consent_to_share")}`);
      }
    }
  };

  const handleReduxCleanup = () => {
    dispatch(setQuestionAnswer(14, ''));
    dispatch(setQuestionAnswerFrench(14, ''));
  }

  return (
    <div>
      <div className="container">
        <div className="row" style={{ paddingTop: "1em" }}></div>
        <BackAnchor onBackClick={handleReduxCleanup} />

        <div className="row">
          <div className="col-sm-8 col-xs-12">
            <h1>{t("without_uploading_bill.header")}</h1>
          </div>
        </div>

        <div>
          {selectOptionError && (
            <div className="form-group has-error">
              <div className="help-block">
                <i
                  aria-label={t("errors.hidden_error_msg")}
                  className="fa fa-exclamation-circle error-indicator errorAlert"
                  aria-hidden="true"
                />
                <span className="ns-visually-hidden">
                  {t("errors.hidden_error_msg")}
                </span>
                <span style={{ marginLeft: "10px" }}>
                  {t("errors.select_option")}
                </span>
              </div>
            </div>
          )}
          <div style={{ marginBottom: "20px" }}>
            <div
              className="ns-radios__item"
              onClick={() => {
                dispatch(setQuestionAnswer(14, 'No', false));
                dispatch(setQuestionAnswerFrench(14, t('shared.no'), false));
              }}
            >
              <div>
                <input
                  className="ns-radios__input"
                  type="radio"
                  id="no-heating-proof-upload"
                  name="no-heating-proof-upload"
                  value={t("shared.no")}
                  onChange={(e) => {
                    dispatch(setQuestionAnswer(14, 'No', false));
                    dispatch(setQuestionAnswerFrench(14, t('shared.no'), false));
                  }}
                  checked={heatingProofUpload === false}
                />
                <label
                  className="ns-label ns-radios__label"
                  htmlFor="no-heating-proof-upload"
                >
                  <span className="ns-label-span">
                    {t("without_uploading_bill.bullet1_text")}
                    <br />
                    <span className="ns-label-helper">
                      {t("without_uploading_bill.bullet1_helper_text")}
                    </span>
                  </span>
                </label>
              </div>
            </div>
          </div>
          <div style={{ marginBottom: "20px" }}>
            <div
              className="ns-radios__item"
              onClick={() => {
                dispatch(setQuestionAnswer(14, 'Yes', true));
                dispatch(setQuestionAnswerFrench(14, t('shared.yes'), true));
              }}
            >
              <input
                className="ns-radios__input"
                type="radio"
                id="heating-proof-upload"
                name="heating-proof-upload"
                value={t("shared.yes")}
                onChange={(e) => {
                  dispatch(setQuestionAnswer(14, 'Yes', true));
                  dispatch(setQuestionAnswerFrench(14, t('shared.yes'), true));
                }}
                checked={heatingProofUpload}
              />
              <label
                className="ns-label ns-radios__label"
                htmlFor="heating-proof-upload"
              >
                <span className="ns-label-span">
                  <b>{t("without_uploading_bill.bullet2_text")}</b>
                </span>
              </label>
            </div>
          </div>
        </div>
        <ContinueCancelButtons continueClick={onNext} />
      </div>
    </div>
  );
};

export default withTranslation("common")(StartHarpPageView);
